<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="sourceMeeting">Source Meeting</label>
                    <wj-combo-box
                        id="sourceMeeting"
                        name="sourceMeeting"
                        [(ngModel)]="selectedMeetingId"
                        [itemsSource]="meetings"
                        [displayMemberPath]="'name'"
                        [selectedValuePath]="'id'"
                        [placeholder]="'Select a meeting'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-primary" (click)="confirm()" [disabled]="!selectedMeetingId">{{ confirmText }}</button>
        <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
    </div>
</form>
